export default {"src":"/_next/static/media/ngo.c0579aba.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};